import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 13 18"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M.04 17.999V.719h6.91q1.848 0 2.988.744 1.14.732 1.668 1.848t.528 2.256q0 1.452-.66 2.412a3.12 3.12 0 0 1-1.788 1.284v-.6q1.62.336 2.424 1.5.816 1.164.816 2.604 0 1.548-.576 2.724a4.2 4.2 0 0 1-1.728 1.848q-1.164.66-2.928.66zm3.311-3.072H7.36q.66 0 1.176-.276.516-.288.804-.792.3-.516.3-1.212 0-.612-.252-1.092a1.8 1.8 0 0 0-.768-.756q-.504-.288-1.26-.288H3.351zm0-7.464h3.552a2.4 2.4 0 0 0 .984-.192 1.53 1.53 0 0 0 .684-.588q.252-.408.252-1.044 0-.792-.492-1.332t-1.428-.54H3.351z"
    }, null, -1)
  ]))]))
}
export default { render: render }